import { SafePlugin } from '@atlaskit/editor-common/safe-plugin';
import { pluginFactory } from '@atlaskit/editor-common/utils';
import { PluginKey } from '@atlaskit/editor-prosemirror/state';
import reducer from './reducer';
var pluginKey = new PluginKey('mediaPixelResizingPlugin');
var _pluginFactory = pluginFactory(pluginKey, reducer, {
    onSelectionChanged: function onSelectionChanged() {
      return {
        isPixelEditorOpen: false
      };
    }
  }),
  createPluginState = _pluginFactory.createPluginState,
  createCommand = _pluginFactory.createCommand,
  getPluginState = _pluginFactory.getPluginState;
export var createPlugin = function createPlugin(_ref) {
  var dispatch = _ref.dispatch;
  return new SafePlugin({
    state: createPluginState(dispatch, {
      isPixelEditorOpen: false
    }),
    key: pluginKey
  });
};
export { createCommand, getPluginState };